<template>
  <div>
    <div class="common-header-wrap">
      <mt-header title="استقر المتجر" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>
    <step :options="options" :active="0"></step>
    <div class="label">تخزين ومعلومات الاتصال</div>
    <mt-field :label="storeJoinin.store_type==1?'اسم المتجر':'اسم الشركة'" v-model="storeJoinin.company_name"></mt-field>
    <div @click="onRegion('company_address')"><mt-cell title="موقعك" is-link>{{storeJoinin.company_address}}</mt-cell></div>
    <div @click="popMap=true"><mt-cell title="تبوك" is-link>{{storeJoinin.company_address_detail}}</mt-cell></div>
    <mt-field v-if="storeJoinin.store_type==0" label="رأس المال المسجل (ألف دولار أمريكي)" v-model="storeJoinin.company_registered_capital"></mt-field>
    <mt-field label="اسم جهة الاتصال" v-model="storeJoinin.contacts_name"></mt-field>
    <mt-field label="رقم الاتصال" v-model="storeJoinin.contacts_phone"></mt-field>
    <mt-field label="بريد الالكتروني" v-model="storeJoinin.contacts_email"></mt-field>
    <div class="label">{{storeJoinin.store_type==0?'معلومات الرخصة التجارية (نسخة)':'معلومات الهوية'}}</div>
    <mt-field :label="storeJoinin.store_type==0?'رقم الرخصة التجارية':'رقم الهوية'" v-model="storeJoinin.business_licence_number"></mt-field>
    <div v-if="storeJoinin.store_type==0" @click="onRegion('business_licence_address')"><mt-cell title="موقع الرخصة التجارية" is-link>{{storeJoinin.business_licence_address}}</mt-cell></div>
    <div v-if="storeJoinin.store_type==0" @click="onDate('business_licence_start')"><mt-cell title="بداية الصلاحية" is-link>{{storeJoinin.business_licence_start}}</mt-cell></div>
    <div v-if="storeJoinin.store_type==0" @click="onDate('business_licence_end')"><mt-cell title="انتهاء الصلاحية" is-link>{{storeJoinin.business_licence_end}}</mt-cell></div>
    <mt-field v-if="storeJoinin.store_type==0" label="نطاق الأعمال" v-model="storeJoinin.business_sphere"></mt-field>
    <mt-cell class="pt-5" :title="storeJoinin.store_type==0?'الرخصة التجارية الالكترونية':'صور الهوية'">
      <div class="user-avatar-wrapper">
        <div v-if="storeJoinin.business_licence_number_electronic" class="user-avatar">
          <img :src="storeJoinin.business_licence_number_electronic_url" @click="openImage(storeJoinin.business_licence_number_electronic_url)">
          <span @click="dropImage()" class="del-btn iconfont">&#xe6d8;</span>
        </div>
        <div v-else class="user-avatar iconfont icon-xiangji" ref="upload_btn1" @change="uploadImage('business_licence_number_electronic',$event)">
          <div class="center-text">الكاميرا / الألبوم</div>
          <input type="file" accept="image/*">
        </div>
      </div>
    </mt-cell>
    <mt-button size="large" type="primary" @click="nextStep" class="ds-button-large mt-10">الخطوة التالية</mt-button>

    <div>
      <mt-popup v-model="isshow" popup-transition="popup-fade" class="popup" >
        <img :src="showimage" :style="getBannerStyle" @click="isshow=false">
      </mt-popup>
    </div>
    <div>
      <region-picker ref="picker" @onConfirm="onPickerConfirm"></region-picker>
      <mt-datetime-picker
              ref="datePicker"
              type="date"
              :startDate="new Date('2000/1/1')"
              yearFormat="{value}-"
              monthFormat="{value}-"
              dateFormat="{value}"
              :value="selectData?(new Date(selectData)):(new Date())"
              @confirm="dateConfirm"
      >
      </mt-datetime-picker>
    </div>
    <div>
      <mt-popup v-model="popMap" position="right" class="common-popup-wrapper">
        <div class="common-header-wrap">
          <mt-header title="التمركز" class="common-header">
            <mt-button slot="left" icon="back" @click="popMap=false"></mt-button>
          </mt-header>
        </div>
        <div class="common-popup-content">
          <map-select ref="map_select" :longitude="storeJoinin.store_longitude" :latitude="storeJoinin.store_latitude" @setPosition="setPosition"></map-select>
        </div>
      </mt-popup>
      <mt-popup position="right" v-model="showCrop" class="crop-wrapper common-popup-wrapper">
        <div class="common-header-wrap">
          <mt-header title="قص الصورة" class="common-header">
            <mt-button slot="left" icon="back" @click="showCrop=false"></mt-button>
            <mt-button slot="right" @click="useCrop">استعمال</mt-button>
          </mt-header>
        </div>
        <vue-cropper class="common-popup-content" style="height: auto;position: absolute" ref="cropper" :maxImgSize="cropperOption.maxImgSize" :autoCropWidth="cropperOption.autoCropWidth" :autoCropHeight="cropperOption.autoCropHeight" :autoCrop="cropperOption.autoCrop" :img="cropperOption.img" :canMove="cropperOption.canMove" :outputType="cropperOption.outputType"></vue-cropper>
      </mt-popup>
    </div>
  </div>
</template>
<script>
import { VueCropper } from 'vue-cropper'
import { Toast, Indicator } from 'mint-ui'
import { mapState, mapMutations, mapActions } from 'vuex'
import Step from '../../Step'
import RegionPicker from '../../RegionPicker'
import MapSelect from '../../../components/MapSelect'
import { getStoreJoinin, uploadInfoFile, saveStoreJoinin2 } from '../../../api/seller'
import { getPointByAddress } from '../../../util/bmap'
export default {
  components: {
    Step,
    RegionPicker,
    MapSelect,
    VueCropper
  },
  data () {
    return {
      cropperOption: {
        img: '',
        canMove: false,
        autoCrop: true,
        autoCropWidth: 100,
        autoCropHeight: 100,
        maxImgSize: 500,
        outputType: 'png'
      },
      showCrop: false,
      options: [{ title: 'تأهيل الشركة' }, { title: 'المؤهل المالي' }, { title: 'معلومات المتجر' }, { title: 'توقيع عقد' }],
      showimage: '',
      isshow: false,
      popMap: false,
      selectData: '',
      regionName: '',
      dataName: ''
    }
  },
  mounted () {
  },
  computed: {
    ...mapState({
      storeJoinin: state => state.member.storeJoinin,
      config: state => state.config.config
    }),
    getBannerStyle: function () {
      const { width, height } = window.screen
      let itemWidth = width
      let itemHeight = height
      return {
        maxWidth: itemWidth + 'px',
        maxHeight: itemHeight + 'px'
      }
    }
  },
  created: function () {
    getStoreJoinin().then(res => {
      var store_joinin = res.result.store_joinin
      if (store_joinin) {
        if (store_joinin.joinin_state == 11 || store_joinin.joinin_state == 20 || store_joinin.joinin_state == 31) {
          this.$router.push({ name: 'SellerJoinin5' })
          return
        }
        if (store_joinin.joinin_state == 40) {
          Toast('تم فتح متجرك')
          this.$router.push({ name: 'HomeSellerLogin' })
          return
        }
        // if (!this.storeJoinin) {
        this.sellerJoininSave({ storeJoinin: store_joinin })
        // }
        this.fetchConfig({}).then(
          response => {
            if (this.config.store_joinin_open == 2 || this.config.store_joinin_open == 3) {
              if (this.config.store_joinin_open == 3) {
                this.storeJoinin['store_type'] = 1
              }
              if (this.config.store_joinin_open == 2) {
                this.storeJoinin['store_type'] = 0
              }
              this.$forceUpdate()
            }
          },
          error => {
            Toast(error.message)
          }
        )
      }
    }).catch(error => {
      Toast(error.message)
    })
  },

  methods: {
    ...mapActions({
      fetchConfig: 'fetchConfig'
    }),
    ...mapMutations({
      memberPoint: 'memberPoint',
      sellerJoininSave: 'sellerJoininSave'
    }),
    nextStep () {
      saveStoreJoinin2(this.storeJoinin).then(res => {
        this.sellerJoininSave({ storeJoinin: this.storeJoinin })
        this.$router.push({ name: 'SellerJoinin3' })
      }).catch(error => {
        Toast(error.message)
      })
    },
    setPosition (lat, lng, name) {
      this.popMap = false
      this.storeJoinin.company_address_detail = name
      this.storeJoinin.store_longitude = lng
      this.storeJoinin.store_latitude = lat
      this.$forceUpdate()
    },
    dateConfirm (value) {
      this.storeJoinin[this.dataName] = value.getFullYear() + '/' + (value.getMonth() + 1) + '/' + value.getDate()
      this.$forceUpdate()
    },
    onDate (name) {
      if (this.storeJoinin[name]) {
        this.selectData = this.storeJoinin[name]
      }
      this.dataName = name
      this.$refs.datePicker.open()
    },
    onPickerConfirm (values) {
      if (this.regionName == 'company_address') {
        this.storeJoinin.company_address = this.getRegionStr(values)
        this.storeJoinin.company_province_id = values[values.length - 1].area_id
      }
      if (this.regionName == 'business_licence_address') {
        this.storeJoinin.business_licence_address = this.getRegionStr(values)
      }
      this.selectCity(values.length > 1 ? values[1].area_name : values[0].area_name)
      this.$forceUpdate()
    },
    onRegion (name) {
      this.regionName = name
      this.$refs.picker.currentValue = true
    },
    getRegionStr (values) {
      let title = ''
      for (let i = 0; i < values.length; i++) {
        const element = values[i]
        if (i !== 0) {
          title = title + ' ' + element.area_name
        } else {
          title = title + element.area_name
        }
      }
      return title
    },
    openImage (src) {
      this.showimage = src
      this.isshow = true
    },
    dropImage () {
      this.storeJoinin.business_licence_number_electronic = ''
      this.$forceUpdate()
    },
    useCrop () {
      this.$refs.cropper.getCropBlob(res => {
        let files = new window.File([res], 'temp.png', { type: res.type })
        let formdata = new FormData()

        formdata.append('file', files)
        formdata.append('name', 'file')

        uploadInfoFile(formdata).then(res => {
          this.storeJoinin.business_licence_number_electronic = res.result.path
          this.storeJoinin.business_licence_number_electronic_url = res.result.url
          this.showCrop = false
          Indicator.close()
          this.$forceUpdate()
        }).catch(function (error) {
          Toast(error.message)
          Indicator.close()
        })
      })
    },
    uploadImage (type, event) {
      let that = this
      let file = event.target.files[0]
      let reader = new FileReader()
      let rs = reader.readAsDataURL(file)
      reader.onload = (e) => {
        that.cropperOption.img = e.target.result
        let image = new Image()
        image.src = e.target.result
        image.onload = function () {
          that.cropperOption.autoCropWidth = window.screen.width
          that.cropperOption.autoCropHeight = this.height / this.width * window.screen.width
          that.cropperOption.maxImgSize = window.screen.height - 40
          that.showCrop = true
          that.$forceUpdate()
        }
      }
    },
    selectCity (city_name) {
      getPointByAddress(city_name).then(res => {
        if (res.result.location) {
          var lng = res.result.location.lng
          var lat = res.result.location.lat
          if (this.regionName == 'company_address') {
            this.storeJoinin.store_latitude = lat
            this.storeJoinin.store_longitude = lng
          }
          if (this.regionName == 'business_licence_address') {

          }

          this.memberPoint({ point: { lng: lng, lat: lat, address: res.result.sematic_description, cityCode: res.result.cityCode, cityName: city_name } })
          // this.$forceUpdate()
        } else {
          Toast('تعذر الحصول على موقع المدينة')
        }
      }).catch(function (error) {
        Toast(error.message)
      })
    }

  }
}
</script>
<style  lang="scss" scoped>
  .container {
    background: #fff;
  }
  .label {
    padding: .5rem;
    font-size: .7rem;
    background: #eee;
  }
  .user-avatar-wrapper{display: inline-block;vertical-align: top;margin-right: .5rem;margin-bottom:.5rem}
  .user-avatar-wrapper .del-btn{position:absolute;bottom:.2rem;right:.2rem}
  .user-avatar {
    display: block;
    border:1px solid #eee;
    position: relative;
    width: 5rem;
    height: 5rem;
    margin: 0 auto;
    text-align: center;
    img {
      width: 100%;
      height: 100%
    }
    input {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0
    }
    .center-text{padding:.2rem;padding-top:3.5rem;font-size:.6rem}
  }
  .user-avatar::before {
    position: absolute;
    font-size: 1.5rem;
    line-height: 5rem;
    left: 50%;
    margin-left: -.75rem;
    color: rgba(0, 0, 0, 0.5)
  }
</style>
